import { PageProps } from "@ezhou/core";

import { cloneFormModel } from "../../components/dataFormUtil";
import { DevExtremeDataForm } from "../../components/DevExtremeDataForm";

import { JeExportByPostingDateModel } from "./model/jeExport";
import { PostingDateFormMetaData } from "./model/metaData";

type SelectPostingDateFormProps = {
  pageProps: PageProps;
  jeExport: JeExportByPostingDateModel;
};

type FormData = {
  jeExport: JeExportByPostingDateModel;
  editable?: boolean;
};

export function SelectPostingDate(props: SelectPostingDateFormProps) {
  const formData: FormData = { jeExport: props.jeExport, editable: false };
  const formModel = cloneFormModel(PostingDateFormMetaData);

  return (
    <>
      <DevExtremeDataForm pageProps={props.pageProps} formModel={formModel} formData={formData} />
    </>
  );
}
